import React, { useEffect, useState } from "react";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import ProductDetails from "./shop-components/shop-details";
import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import { API_BASE_URL } from "../api/config";
import { withAppData } from "../app/withAppData";

const Product_Details = (props) => {
  const slug = props.match?.params?.slug;
  const { lang, loading } = props.appData;
  const [post, setPost] = useState(null);

  const fetchBySlug = async (slug) => {
    const res = await fetch(`${API_BASE_URL}/product/get/${slug}`);
    if (!res.ok) throw new Error("not_found");
    return (await res.json())?.data;
  };

  useEffect(() => {
    const load = async () => {
      try {
        const post = await fetchBySlug(slug);
        setPost(post);
      } catch (err) {
        console.error(err);
      }
    };
    load();
  }, [slug]);

  return (
    <div>
      <Navbar />
      <PageHeader
        lang={lang}
        headertitle={
          post?.translations?.[lang]?.name || post?.slug || "Ürün Detay"
        }
        subheader={[
          lang === "en" ? "Products" : "Ürünler",
          post?.mainCategory?.translations?.[lang]?.name || "Kategori",
          post?.translations?.[lang]?.name || post?.slug || "Ürün Detay",
        ]}
        subheaderPaths={[
          "/urunler",
          {
            pathname: "/urunler",
            state: { categoryId: post?.mainCategory?._id },
          },
          null, // Current page - no link
        ]}
      />
      <ProductDetails post={post} lang={lang} loading={loading} />
      <CallToActionV1 />
      <Footer />
    </div>
  );
};

export default withAppData(Product_Details);
